<template>
  <div class="mobilefeedback">
    <Form ref="searchForm" :label-width="70" inline>
      <FormItem label="状态">
        <Select v-model="searchCondition.is_read" style="width:200px;" clearable>
          <Option v-for="(item,index) in readStatus" :key="index" :value="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="手机号码">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入用户手机号码"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="反馈内容">
        <Input
          v-model="searchCondition.content"
          placeholder="请输入反馈内容关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/feedback"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="uid"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDetail(row)">查看详情</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal class="modal" v-model="modal.show" title="反馈内容" width="500" @on-cancel="onModalOk">
      <pre class="Detail">{{content}}</pre>
      <div slot="footer" style="text-align:center;">
        <Button
          type="primary"
          size="large"
          @click="onModalOk"
          style="width:100px;"
        >{{modal.btnLabel}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import * as enums from "@/utils/enums";
export default {
  name: "mobilefeedback",
  data() {
    return {
      readStatus: enums.ReadStatus.getOptions(),
      tableColumns: [
        { title: "用户昵称", key: "nickname", align: "center", minWidth: 120 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 120 },
        { title: "状态", key: "is_read", align: "center", minWidth: 120 },
        {
          title: "提交时间",
          key: "created_at",
          align: "center",
          minWidth: 120
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 140,
          fixed: "right"
        }
      ],
      modal: {
        show: false,
        title: "",
        type: "",
        btnLabel: ""
      },
      searchCondition: {
        id: "",
        is_read: "",
        mobile: "",
        nickname: "",
        init: function() {
          this.is_read = "";
          this.mobile = "";
          this.content = "";
        }
      },
      content: ""
    };
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.is_read = enums.ReadStatus.getValue(i.is_read);
        i.created_at = this.$pub.timestampToTime(i.created_at);
        this.searchCondition.id = i.id;
      });
    },
    onDetail(row) {
      this.modal.show = true;
      this.modal.btnLabel = "关闭";
      this.$http.get("/api/feedback/" + row.id).then(data => {
        this.content = data.content;
      });
    },
    onModalOk() {
      this.modal.show = false;
      setTimeout(() => {
        this.$refs.grid.refresh();
      }, 300);
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除该反馈吗？",
        onOk: () => {
          this.$http.delete("/api/feedback/" + row.id).then(() => {
            this.$Message.success("删除成功!");
            this.$refs.grid.refresh();
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.Detail {
  min-height: 200px;
  margin: 0;
  padding: 0;
  white-space: pre-wrap;
}
</style>




